import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { ArrowLeftIcon, ArrowRightIcon } from '@heroicons/react/outline';
import Button from '../Button';
import Divider from '../../common/components/Divider';

const PageHeader = ({
  title,
  subTitle,
  description,
  extra,
  onBack,
  isNewPresentation,
  children,
}) => {
  const { i18n } = useTranslation();
  const languageDirection = i18n.dir();
  const isLanguageDirectionLTR = languageDirection === 'ltr';

  return (
    <div
      className={`cluster-6 justify-between items-center ${
        isNewPresentation
          ? 'bg-surface border-b border-divider py-2 px-4 min-h-16'
          : ''
      }`}
    >
      <div className="cluster-2 items-center min-w-0">
        {onBack && (
          <>
            <Button
              data-testid="page-button-back"
              type="tertiary"
              icon={
                isLanguageDirectionLTR ? <ArrowLeftIcon /> : <ArrowRightIcon />
              }
              onClick={onBack}
            />
            <Divider.Vertical />
          </>
        )}
        {children || (
          <div className="stack-0 min-w-0">
            <div className="stack-0">
              <h1
                data-testid="page-header"
                // NOTE: Have to use "text-body" because Ant Designs styles make headers black
                className={`text-body ${
                  isNewPresentation
                    ? 'text-base font-medium'
                    : 'text-xl font-normal'
                }`}
              >
                {title}
              </h1>
              <p data-testid="page-subheader" className="text-sm">
                {subTitle}
              </p>
            </div>
            {description && (
              <p
                data-testid="page-header-description"
                className={`text-sm text-secondary ${
                  isNewPresentation ? 'truncate' : ''
                }`}
              >
                {description}
              </p>
            )}
          </div>
        )}
      </div>
      {extra}
    </div>
  );
};

PageHeader.propTypes = {
  title: PropTypes.node.isRequired,
  subTitle: PropTypes.node,
  description: PropTypes.string,
  children: PropTypes.node,
  extra: PropTypes.node,
  onBack: PropTypes.func,
  isNewPresentation: PropTypes.bool,
};

PageHeader.defaultProps = {
  subTitle: null,
  description: null,
  children: null,
  extra: null,
  onBack: null,
  isNewPresentation: false,
};

export default PageHeader;
